import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "./api";

export function useDebouncedList(path, params, initial) {
  const [data, setData] = useState(initial);
  const reqId = useRef(0);
  const load = useCallback(() => {
    const id = ++reqId.current;
    return api.get(path, { params }).then(({ data: d }) => { if (id === reqId.current) setData(d); });
  }, [path, params]);
  useEffect(() => { const t = setTimeout(load, 300); return () => clearTimeout(t); }, [load]);
  return [data, load];
}
